import React from "react";
import classNames from "classnames";
import * as AccordionRadix from "@radix-ui/react-accordion";
import { ChevronIcon } from "components/icons/icons";

type TriggerProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: string | React.ReactNode;
};

const Trigger = React.forwardRef<HTMLButtonElement, TriggerProps>(
  ({ children, ...props }, forwardedRef) => {
    const focusCommonStyles =
      "focus:outline-none focus-visible:outline-none focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring focus-visible:ring-pro-blue";

    return (
      <AccordionRadix.Header className="flex w-full last:border-b">
        <AccordionRadix.Trigger
          ref={forwardedRef}
          className={classNames(
            "trigger",
            "align-left flex inline-flex w-full items-center justify-between border-t border-[#C8C8CC] bg-white px-[14px] py-3 text-left font-bold text-[16px] leading-[130%] text-black-rock",
            "transition-[color,transform,border-color] duration-200",
            "hover:text-cerise data-[state=open]:mt-[-1px] data-[state=open]:border-t-2 data-[state=open]:border-cerise",
            "[&_.chevron-icon]:data-[state=open]:rotate-180",
            focusCommonStyles
          )}
          {...props}
        >
          <span>{children}</span>
          <span
            className={
              "chevron-icon relative inline-flex h-[24px] w-[24px] transition-[transform,color,stroke] duration-200"
            }
          >
            <ChevronIcon width={24} />
          </span>
        </AccordionRadix.Trigger>
      </AccordionRadix.Header>
    );
  }
);

export default Trigger;
